import { useState } from "react";
import { rpc, translateError } from "@vixio/data";
import { Button, Callout, Select, TextInput } from "@vixio/ui";

export function slugify(name: string): string {
  return name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 63);
}

const KINDS = [
  { value: "company", label: "Empresa" },
  { value: "institute", label: "Instituto" },
  { value: "client", label: "Cliente" },
  { value: "partner", label: "Parceiro" },
];

/** Cria organização por core.create_organization (bootstrap ou administrador da plataforma). */
export function CreateOrganizationForm({ onCreated, submitLabel = "Criar organização" }: { onCreated: (id: string) => void | Promise<void>; submitLabel?: string }) {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [slugTouched, setSlugTouched] = useState(false);
  const [kind, setKind] = useState("company");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const effectiveSlug = slugTouched ? slug : slugify(name);
  const slugError = effectiveSlug && !/^[a-z0-9][a-z0-9-]{1,62}$/.test(effectiveSlug) ? "Use letras minúsculas, números e hífen (2 a 63)." : null;

  return (
    <form
      className="vx-stack"
      noValidate
      onSubmit={async (e) => {
        e.preventDefault();
        setError(null);
        if (name.trim().length < 2) {
          setError("Informe o nome da organização.");
          return;
        }
        if (slugError) return;
        setBusy(true);
        try {
          const id = (await rpc("core", "create_organization", { p_name: name.trim(), p_slug: effectiveSlug, p_kind: kind })) as string;
          await onCreated(id);
        } catch (err) {
          setError(translateError(err).message);
        } finally {
          setBusy(false);
        }
      }}
    >
      <TextInput label="Nome" value={name} onChange={setName} required autoComplete="organization" />
      <TextInput
        label="Identificador"
        value={effectiveSlug}
        onChange={(v) => {
          setSlugTouched(true);
          setSlug(v.toLowerCase());
        }}
        hint="Usado em links públicos (ex.: vixio). Não muda depois."
        error={slugError}
        className="mono"
      />
      <Select label="Tipo" value={kind} onChange={setKind} options={KINDS} />
      {error ? <Callout tone="crit">{error}</Callout> : null}
      <div className="vx-form-actions">
        <Button type="submit" variant="primary" loading={busy}>
          {submitLabel}
        </Button>
      </div>
    </form>
  );
}
